export default "__VITE_ASSET__65999d1b__"